export const TypographyType = {
  H1: 'H1',
  H2: 'H2',
  H3: 'H3',
  H4: 'H4',
  B1: 'B1',
  B1Condensed: 'B1Condensed',
  B1C: 'B1Condensed',
  B2: 'B2',
  B2Condensed: 'B2Condensed',
  B2C: 'B2Condensed'
};

export const TypographyWeight = {
  EXTRA_BOLD: 'EXTRA_BOLD',
  BOLD: 'BOLD',
  SEMI_BOLD: 'SEMI_BOLD',
  REGULAR: 'REGULAR',
  LIGHT: 'LIGHT',
  THIN: 'THIN',
  EXTRA_THIN: 'EXTRA_THIN'
};

export const Weight = {
  [TypographyWeight.EXTRA_BOLD]: 800,
  [TypographyWeight.BOLD]: 700,
  [TypographyWeight.SEMI_BOLD]: 500,
  [TypographyWeight.REGULAR]: 400,
  [TypographyWeight.LIGHT]: 300,
  [TypographyWeight.THIN]: 200,
  [TypographyWeight.EXTRA_THIN]: 100
};
